module.exports = __webpack_public_path__ + "static/media/ship_green_flip.64512d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_green_flip.png
// module id = 209
// module chunks = 0